import React from "react";
// @ts-ignore
import MUIDataTable from "mui-datatables";
// @ts-ignore
import { MUIDataTableColumn } from "mui-datatables";
import * as XLSX from 'xlsx';

type TableProps = {
  data: Object[];
  col: MUIDataTableColumn[];
  options?: Object;
  title: string;
};

const Datatables = (props: TableProps) => {
  const { data, col, title = 'Data' } = props;

  const defOptions = {
    filterType: 'multiselect',
    responsive: 'standard',
    filter: true,
    search: true,
    sort: true,
    pagination: true,
    selectableRows: "none",
    rowsPerPage: 5,
    rowsPerPageOptions: data.length > 100 ? [5, 20, 50, 100, { value: data.length, label: "All" }] : [5, 20, 50, 100],
    textLabels: {
      toolbar: {
        downloadCsv: "Download Excel",
      },
    },
    onDownload: (
      buildHead: (columns: any[]) => string,
      buildBody: (data: any[]) => string,
      columns: {
        label: string;
        name: string;
        download: boolean;
      }[],
      data: {
        index: number;
        data: (string | number | boolean | null)[];
      }[]
    ) => {
      const includedIndexes = columns.flatMap((col, i) =>
        col.download === false ? [] : [i]
      );

      const headers = includedIndexes.map(i => columns[i].label);
      const rows = data.map(row => includedIndexes.map(i => row.data[i]));

      const worksheetData = [headers, ...rows];

      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `${title}.xlsx`);

      return false;
    },
  };

  const { options = defOptions} = props;

  return (
    <div>
      <MUIDataTable
        data={data}
        columns={col}
        options={options}
        className="datatables"
        componentsProps={{
    pagination: {
      sx: {
        borderTop: 'none', // hilangin border atas di pagination
      },
    },
  }}
      />
    </div>
  );
};

export default Datatables;
